import { _ } from "svelte-i18n";
import { get } from "svelte/store";
//Fast memory for multiple calls
let countryArray = null;
export function getSupportedCountryList() {
    if (!countryArray) {
        countryArray = [
            {
                value: "CH",
                displayName: get(_)("general.country.lbl_ch"),
                postalName: "SWITZERLAND"
            },
            {
                value: "DE",
                displayName: get(_)("general.country.lbl_de"),
                postalName: "GERMANY"
            },
            {
                value: "IT",
                displayName: get(_)("general.country.lbl_it"),
                postalName: "ITALY"
            },
            {
                value: "FR",
                displayName: get(_)("general.country.lbl_fr"),
                postalName: "FRANCE"
            },
            {
                value: "LI",
                displayName: get(_)("general.country.lbl_li"),
                postalName: "LIECHTENSTEIN"
            },
            {
                value: "AT",
                displayName: get(_)("general.country.lbl_at"),
                postalName: "AUSTRIA"
            }
        ];
    }
    return countryArray;
}
